export const getDefaultValues = (exchangeConfigDetails) => ({
  AppVersionControlLable: exchangeConfigDetails?.AppVersionControlLable || '',
  AppVersionControlPackageName: exchangeConfigDetails?.AppVersionControlPackageName || '',
  AppVersionControlUrlDownloadApp: exchangeConfigDetails?.AppVersionControlUrlDownloadApp || '',
  AppVersionControlUrlPlayVideo: exchangeConfigDetails?.AppVersionControlUrlPlayVideo || '',
  AppVersionControlChangeLog: exchangeConfigDetails?.AppVersionControlChangeLog || '',
  AppVersionControlVersionApp: exchangeConfigDetails?.AppVersionControlVersionApp || '',
  AppVersionControlVersionVideo: exchangeConfigDetails?.AppVersionControlVersionVideo || '',
  AppVersionControlIsForceUpdate: exchangeConfigDetails?.AppVersionControlIsForceUpdate,
});
